import { render, staticRenderFns } from "./TablaSimulacionSinDetalles.vue?vue&type=template&id=b8b44ba2&"
import script from "./TablaSimulacionSinDetalles.vue?vue&type=script&lang=js&"
export * from "./TablaSimulacionSinDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports